<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M15.0996 16.4405C14.7896 20.0405 12.9396 21.5105 8.88961 21.5105L8.75961 21.5105C4.28961 21.5105 2.49961 19.7205 2.49961 15.2505L2.49961 8.74047C2.49961 4.27047 4.28961 2.48047 8.75961 2.48047L8.88961 2.48047C12.9096 2.48047 14.7596 3.93047 15.0896 7.47047"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M8.99988 12L20.3799 12"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M18.15 15.3504L21.5 12.0004L18.15 8.65039"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
